export function transformPrNumber(key: string, target: 'internal' | 'external') {
	if (target === 'internal') {
		return key.replace(' ', '_');
	}
	return key.replace('-', ' ');
}
